import dealerAddress from './dealerAddress';
import pricing from './pricing';
import incentive from './incentive';
import modal from './modal';
import widgetInfo from './widgetInfo';
import account from './account';
import pricingModuleData from './pricingModule';

const root = {
	dealerAddress,
	pricing,
	incentive,
	modal,
	widgetInfo,
	account,
	pricingModuleData
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js